module.exports = __webpack_public_path__ + "static/media/bath-icon.10778082.svg";